import userService from "./userService";
import { accessGuard, getServerURL } from "../shared/sharedFunctions";
import companyEmployeeService from "./companyEmployeeService";
import domainService from "./domainService";
import policyService from "./policyService";
import ragService from "./ragService";
import darkWebService from "./darkWebService";
import vscanService from "./vscanService";

const CompanyService = () => {
	const pub = {};
	
	pub.company = null;
	pub.companies = [];
	pub.selectedCompany = null;
	
	const selectCompanyCallbacks = [];
	
	pub.all = async () => {
		return new Promise((resolve, reject) => {
			if (!accessGuard([1])) reject(new Error("Unauthorised"));
		
			const req = {
				method: "GET",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
			};
			
			fetch(`${getServerURL()}/api/companies/all`, req)
			.then((response) => {
				if (response.status === 200) {
					return response.json();
				}
				else {
					throw new Error(response.status);
				}
			})
			.then(async (data) => {
				if (data === undefined || !data || !data.hasOwnProperty("companies")) {
					throw new Error("invalid response from getting companies");
				}
				
				pub.companies = data.companies;
				pub.companies.sort((a, b) => a.name.localeCompare(b.name));
				
				for (let i in pub.companies) {
					if (pub.companies[i].id === 1) continue;
					pub.companies[i].company_branding = !!pub.companies[i].company_branding;
				}
				
				if (!pub.selectedCompany && pub.companies.length > 0) {
					await pub.selectCompany(pub.companies[0]);
				}
			})
			.then(() => {
				if (pub.selectedCompany) {
					return userService.updateCompanyUsers(pub.selectedCompany);
				}
			})
			.then(() => {
				if (pub.selectedCompany) {
					return darkWebService.all(pub.selectedCompany.id);
				}
			})
			.then(() => {
				if (pub.selectedCompany) {
					return vscanService.getVscanReports(pub.selectedCompany.id);
				}
			})
			.then(() => {
				return resolve();
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
		
	};
	
	pub.add = (company, user) => {
		return new Promise((resolve, reject) => {
			if (!accessGuard([1])) reject(new Error("Unauthorised"));
			
			const req = {
				method: "POST",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
				body: JSON.stringify({
					name: company.name,
					domain: company.domain,
					user_name: user.name,
					email: user.email,
					company_branding: company.company_branding
				})
			};
			
			fetch(`${getServerURL()}/api/companies/add`, req)
			.then((response) => {
				if (response.status === 200) {
					return response.json();
				}
				else {
					throw new Error(response.status);
				}
			})
			.then((data) => {
				if (data === undefined || !data || !data.hasOwnProperty("company")) {
					throw new Error("invalid response from adding company");
				}
				company = data.company;
				
				return pub.all();
			})
			.then(() => {
				return resolve(company);
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
	}
	
	pub.update = (company) => {
		return new Promise((resolve, reject) => {
			if (!accessGuard([1])) reject(new Error("Unauthorised"));
			
			const req = {
				method: "PUT",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
				body: JSON.stringify({
					name: company.name,
					company_branding: company.company_branding,
					logo: company.logo
				})
			};
			
			fetch(`${getServerURL()}/api/companies/update/${company.id}`, req)
			.then((response) => {
				if (response.status === 200) {
					return response.json();
				}
				else {
					throw new Error(response.status);
				}
			})
			.then((data) => {
				if (data === undefined || !data || !data.hasOwnProperty("company")) {
					throw new Error("invalid response from updating company");
				}
				company = data.company;
				
				return pub.all();
			})
			.then(() => {
				return resolve(company);
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
	};
	
	pub.getPrimaryDomain = (company) => {
		return new Promise((resolve, reject) => {
			if (!accessGuard([1, 2, 3])) reject(new Error("Unauthorised"));
			
			const req = {
				method: "GET",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() }
			};
			
			fetch(`${getServerURL()}/api/domain/primarydomain/${company.id}`, req)
			.then((response) => {
				if (response.status === 200) {
					return response.json();
				}
				else {
					throw new Error(response.status);
				}
			})
			.then((data) => {
				return resolve(data.domain);
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
	};
	
	pub.updateKynd = () => {
		return new Promise((resolve, reject) => {
			if (!accessGuard([1])) reject(new Error("Unauthorised"));
			
			const req = {
				method: "GET",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() }
			};
			
			fetch(`${getServerURL()}/api/jobs/updatekynd`, req)
			.then((response) => {
				if (response.status === 200) {
					return response.json();
				}
				else {
					throw new Error(response.status);
				}
			})
			.then(() => {
				return pub.all();
			})
			.then(() => {
				return resolve();
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
	};
	
	pub.updateBreachAware = () => {
		return new Promise((resolve, reject) => {
			if (!accessGuard([1])) reject(new Error("Unauthorised"));
			
			const req = {
				method: "GET",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() }
			};
			
			fetch(`${getServerURL()}/api/jobs/updatebreachaware`, req)
			.then((response) => {
				if (response.status === 200) {
					return response.json();
				}
				else {
					throw new Error(response.status);
				}
			})
			.then(() => {
				return pub.all();
			})
			.then(() => {
				return resolve();
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
	};
	
	pub.kyndLive = (kyndLiveRequest) => {
		return new Promise((resolve, reject) => {
			if (!accessGuard([1])) reject(new Error("Unauthorised"));
			
			const req = {
				method: "POST",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
				body: JSON.stringify({
					companyId: kyndLiveRequest.companyId,
					user_name: kyndLiveRequest.firstname,
					email: kyndLiveRequest.email					
				})
			};
			
			fetch(`${getServerURL()}/api/jobs/kyndlive`, req)
			.then((response) => {
				if (response.status === 200) {
					return response.json();
				}
				else {
					throw new Error(response.status);
				}
			})
			.then(() => {
				return pub.all();
			})
			.then(() => {
				return resolve();
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
	}
	
	pub.addBreachAware = (breachAwareRequest) => {
		return new Promise((resolve, reject) => {
			if (!accessGuard([1])) reject(new Error("Unauthorised"));
			
			const req = {
				method: "POST",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
				body: JSON.stringify({
					companyId: breachAwareRequest.companyId,
					emailDomain: breachAwareRequest.emailDomain				
				})
			};
			
			fetch(`${getServerURL()}/api/jobs/addbreachaware`, req)
			.then((response) => {
				if (response.status === 200) {
					return response.json();
				}
				else {
					throw new Error(response.status);
				}
			})
			.then(() => {
				return pub.all();
			})
			.then(() => {
				return resolve();
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
	}
	
	pub.updateUsecure = () => {
		return new Promise((resolve, reject) => {
			if (!accessGuard([1])) reject(new Error("Unauthorised"));
			
			const req = {
				method: "GET",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() }
			};
			
			fetch(`${getServerURL()}/api/jobs/updateusecure`, req)
			.then((response) => {
				if (response.status === 200) {
					return response.json();
				}
				else {
					throw new Error(response.status);
				}
			})
			.then(() => {
				return pub.all();
			})
			.then(() => {
				return resolve();
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
	};
	
	pub.addUsecure = (usecureRequest) => {
		return new Promise((resolve, reject) => {
			if (!accessGuard([1])) reject(new Error("Unauthorised"));
			
			const req = {
				method: "POST",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() },
				body: JSON.stringify({
					companyId: usecureRequest.companyId,
					externalId: usecureRequest.externalId
				})
			};
			
			fetch(`${getServerURL()}/api/jobs/addusecure`, req)
			.then((response) => {
				if (response.status === 200) {
					return response.json();
				}
				else {
					throw new Error(response.status);
				}
			})
			.then(() => {
				return pub.all();
			})
			.then(() => {
				return resolve();
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
	}
	
	pub.updateLogo = async (logoData) => {
		pub.selectedCompany.logo = logoData;
		
		for (let i in pub.companies) {
			if (pub.companies[i].id === pub.selectedCompany.id) {
				pub.companies[i].logo = logoData;
				break;
			}
		}
		
		try {
			await pub.update(pub.selectedCompany);
			
			for (let i in selectCompanyCallbacks) {
				selectCompanyCallbacks[i]();
			}
		}
		catch (e) {
			console.log(e.message);
		}
	};
	
	pub.delete = (company) => {
		return new Promise((resolve, reject) => {
			if (!accessGuard([1])) reject(new Error("Unauthorised"));
			
			const req = {
				method: "DELETE",
				headers: { "Content-Type": "application/json", "access_token": userService.AccessToken() }
			};
			
			fetch(`${getServerURL()}/api/companies/delete/${company.id}`, req)
			.then((response) => {
				if (response.status === 200) {
					return response.json();
				}
				else {
					throw new Error(response.status);
				}
			})
			.then(() => {
				return pub.all();
			})
			.then(() => {
				return resolve(company);
			})
			.catch(err => {
				console.log(err.message);
				reject(err);
			});
		});
	}
	
	pub.selectCompany = async (company) => {
		try {
			pub.selectedCompany = company;
			
			await userService.updateCompanyUsers(pub.selectedCompany)
			await companyEmployeeService.all(pub.selectedCompany.id);
			await domainService.all(pub.selectedCompany.id);
			await policyService.getTemplates(pub.selectedCompany.id);
			await policyService.getCompanyPolicies(pub.selectedCompany.id);
			await ragService.all(pub.selectedCompany.id);
			await ragService.getRecommendations(pub.selectedCompany.id);
			await darkWebService.all(pub.selectedCompany.id);
			await vscanService.getVscanReports(pub.selectedCompany.id);
			
			for (let i in selectCompanyCallbacks) {
				selectCompanyCallbacks[i]();
			}
			
			return company;
		}
		catch (e) {
			console.log(e.message);
		}
	}
	
	pub.onSelectCompany = (callback) => {
		let existingCallback = false;
		for (let i in selectCompanyCallbacks) {
			if (selectCompanyCallbacks[i] === callback) {
				existingCallback = true;
				break;
			}
		}
		
		if (!existingCallback) {
			selectCompanyCallbacks.push(callback);
		}
	}
	
	return pub;
};

export default CompanyService();
